import { create } from "zustand";
import { persist } from "zustand/middleware";

type LocationId = number | string;

interface MachineOrderState {
  locationIdToOrder: Record<string, string[]>; // locationId -> array of machine ids (as string)
  getOrder: (locationId: LocationId) => string[] | undefined;
  setOrder: (locationId: LocationId, order: string[]) => void;
  moveInOrder: (locationId: LocationId, fromId: string, toId: string) => void;
}

export const useMachineOrderStore = create<MachineOrderState>()(
  persist(
    (set, get) => ({
      locationIdToOrder: {},
      getOrder: (locationId) => get().locationIdToOrder[String(locationId)],
      setOrder: (locationId, order) =>
        set((state) => ({
          locationIdToOrder: { ...state.locationIdToOrder, [String(locationId)]: order },
        })),
      moveInOrder: (locationId, fromId, toId) =>
        set((state) => {
          const key = String(locationId);
          const current = state.locationIdToOrder[key] ?? [];
          const fromIndex = current.indexOf(fromId);
          const toIndex = current.indexOf(toId);
          if (fromIndex === -1 || toIndex === -1 || fromIndex === toIndex) return state;
          const next = current.slice();
          const [moved] = next.splice(fromIndex, 1);
          next.splice(toIndex, 0, moved);
          return { locationIdToOrder: { ...state.locationIdToOrder, [key]: next } };
        }),
    }),
    { name: "machine-order-store" }
  )
);


